import React, { Component } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import { useEffect } from "react";

//

const ProductSlider = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/products`, {
          method: "GET", // Explicitly specifying GET method
          headers: {
            "Content-Type": "application/json", // Optional header
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        // Extract the products array
        const productsArray = data.products;

        // Map and modify data if needed
        const modifiedData = productsArray.map((item) => {
          const { _id, ...rest } = item;
          return { id: _id, ...rest };
        });

        setProducts(modifiedData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const settings = {
    dots: false,
    infinite: products.length > 1,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <Slider
        {...settings}
        className="img-carousel-content primary btn-style-1"
      >
        {products.map((item, id) => (
          <div class="item">
            <div class="item-box">
              <Link to={`/product-details/${item.id}`}>
                <div class="item-img">
                  <img src={apiUrl + item?.images[0]} alt="" />
                  <div class="item-info-in">
                    <ul>
                      <li>
                        <Link to={`/product-details/${item.id}`}>
                          <i class="ti-eye"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </Link>

              <div class="item-info text-center text-black p-a10">
                <h6 class="item-title text-uppercase font-weight-500">
                  <Link to={`/product-details/${item.id}`}>{item?.name}</Link>
                </h6>

                <h4 class="item-price">
                  <del>{item.oldPrice}</del>
                  <span class="text-primary">{item.price}</span>
                </h4>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default ProductSlider;
